import React from 'react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { useLivedata, useUserConfig } from 'shared'
import LKButton from 'shared/LKButton'

export const initialDate = new LKDate('30.12.1899').instance

export const getPeriodDate = (workPeriod) => new LKDate(initialDate.clone().add(workPeriod, 'days')).toString()

export const getPeriod = (workPeriod, openDay) =>
  new LKDate(new LKDate(openDay).instance.clone().add(-workPeriod, 'days')).toString()

const LKPeriodButton = (props) => {
  const { startDateName, endDateName, change } = props

  const { WorkPeriodStart, WorkPeriodEnd } = useUserConfig(['WorkPeriodStart', 'WorkPeriodEnd'])

  const { OpenDayStr } = useLivedata('OpenDayStatus.Open_Day_Str as OpenDayStr')

  function handleClick() {
    change(
      startDateName,
      WorkPeriodStart < 20000 ? getPeriod(WorkPeriodStart, OpenDayStr) : getPeriodDate(WorkPeriodStart),
    )
    change(endDateName, WorkPeriodEnd < 20000 ? getPeriod(WorkPeriodEnd, OpenDayStr) : getPeriodDate(WorkPeriodEnd))
  }

  return <LKButton alias="period" onClick={handleClick} {...props} />
}

export default LKPeriodButton
